// extracted by mini-css-extract-plugin
export var actions = "_g4-d";
export var benefitCard = "_g4-a";
export var benefitIcon = "_g4-b";
export var benefitLabel = "_g4-c";
export var benefits = "_g4-9";
export var bodyText = "_g4-8";
export var closeButton = "_g4-2";
export var content = "_g4-3";
export var eyebrow = "_g4-4";
export var heading = "_g4-5";
export var image = "_g4-f";
export var imagePanel = "_g4-e";
export var modal = "_g4-0";
export var shell = "_g4-1";
export var title = "_g4-6";
export var titleOffer = "_g4-7";